import { render, staticRenderFns } from "./product-detail-info.vue?vue&type=template&id=0cdaf5e7&scoped=true&"
import script from "./product-detail-info.vue?vue&type=script&lang=js&"
export * from "./product-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./product-detail-info.vue?vue&type=style&index=0&id=0cdaf5e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdaf5e7",
  null
  
)

export default component.exports